import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and middle initial',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const exemptionInitialQuestions = [
  {
    id: 'filing_status',
    title: 'Please select filing status:',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'no_exemptions_or_dependents_claimed',
        shortName: 'Claim neither yourself nor your spouse. You may choose this option if you are married, and have a working spouse or more than one job to avoid having too little tax withheld.',
      },
      {
        codeValue: 'single',
        shortName: 'Claim yourself if you did not claim this exemption in connection with other employment, or if your spouse has not claimed your exemption. You may also choose this option to claim one personal exemption if you will file as head of household.',
      },
      {
        codeValue: 'married',
        shortName: 'Claim yourself and your spouse.',
      },
      {
        codeValue: 'not_applicable',
        shortName: 'Not applicable.',
      },
    ],
  },
];

export const initialAdditionalQuestions = [
  {
    id: 'dependents',
    title: 'Enter the number of dependents, not including yourself or your spouse, whom you will claim on your tax return. If no dependents are claimed, enter “0.”',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Increase or decrease in the amount to be withheld each pay period. Decreases should be indicated as a negative amount.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^-?[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
